import React, {useState, useEffect} from "react";
import "./weatherforecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props){

    const [loaded, setLoaded] = useState(false);
    const [forecast, setForecast] = useState (null);
    

     useEffect(() => {
    setLoaded(false);
    }, [props.coordinates]);
    
    function handleResponse(response){
        setForecast(response.data.daily);
        setLoaded(true);
        
    }

     if (loaded) {
    return (
      <div className="WeatherForecast">
        <div className="row">
          {forecast.map(function (dailyForecast, index) {
            if (index < 5) {
              return (
                <div className="col" key={index}>
                  <WeatherForecastDay data={dailyForecast} />
                </div>
              );
            } else{
                return null;
            }
          })}
    </div>
    </div>
    );
    } else{

    let apiKey = "5201594abea9f3e38b70e65b11a80c24";
    let latitude = props.coordinates.lat;
    let longitude = props.coordinates.lon;
    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);

    return "Loading";

    }

}